import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
var FeederpopupComponent = /** @class */ (function () {
    function FeederpopupComponent(data, feederService, dialogRef, ngxLoader) {
        var _this = this;
        this.data = data;
        this.feederService = feederService;
        this.dialogRef = dialogRef;
        this.ngxLoader = ngxLoader;
        this.displayedColumns = ["FeederID", "SiteName", "KVARating", "LastUpdatedTime", "Status",];
        this.displayedColumnsAlert = ["FeederID", "SiteName", 'ParamName', "ActualValue", "ThresholdValue"];
        this.isTile = false;
        this.isTileData = true;
        this.isAlert = false;
        this.isAlertData = true;
        this.doFilter = function (value) {
            _this.dataSource.filter = value.trim().toLocaleLowerCase();
        };
    }
    FeederpopupComponent.prototype.ngOnInit = function () {
        this.state = this.data.state;
        this.selected = this.data.selected;
        this.feederList = this.data.feederOptions;
        if (this.selected.toLowerCase() == 'tile') {
            this.isTile = true;
            this.isAlert = false;
            this.getTileData(this.state);
        }
        else if (this.selected.toLowerCase() == 'alert') {
            this.isAlert = true;
            this.isTile = false;
            this.getAlertTileData(this.state);
        }
    };
    FeederpopupComponent.prototype.getTileData = function (state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ngxLoader.startLoader('tile');
                        this.responseData = null;
                        if (!(state.toLowerCase() == 'all')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.feederService.getFeederPopupTileData({ 'feederList': this.feederList, 'state': this.state }).subscribe(function (response) {
                                console.log("RESPONSE>>>>>>", response);
                                if (response.data.length > 0) {
                                    _this.isTileData = true;
                                    _this.responseData = response.data;
                                    _this.dataSource = new MatTableDataSource(_this.responseData);
                                    _this.dataSource.paginator = _this.paginator;
                                    _this.dataSource.sort = _this.sort;
                                    console.log('DataSource>>>>>>>', _this.dataSource.filteredData);
                                }
                                else {
                                    _this.isTileData = false;
                                }
                                _this.ngxLoader.stopLoader('tile');
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 2:
                        if (!(state.toLowerCase() == 'online')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.feederService.getFeederPopupTileData({ 'feederList': this.feederList, 'state': this.state }).subscribe(function (response) {
                                console.log("RESPONSE>>>>>>", response);
                                if (response.data.length > 0) {
                                    _this.isTileData = true;
                                    _this.responseData = response.data;
                                    //dummyData = response.data;
                                    _this.responseData.forEach(function (element) {
                                        if (element.alert.length > 0) {
                                            element.status = 'alert';
                                        }
                                        else {
                                            element.status = 'online';
                                        }
                                    });
                                    console.log("Dummy Data>>>>>>", _this.responseData);
                                    _this.dataSource = new MatTableDataSource(_this.responseData);
                                    _this.dataSource.paginator = _this.paginator;
                                    _this.dataSource.sort = _this.sort;
                                    console.log('DataSource>>>>>>>', _this.dataSource);
                                }
                                else {
                                    _this.isTileData = false;
                                }
                                _this.ngxLoader.stopLoader('tile');
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 4:
                        if (!(state.toLowerCase() == 'offline')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.feederService.getFeederPopupTileData({ 'feederList': this.feederList, 'state': this.state }).subscribe(function (response) {
                                console.log("RESPONSE>>>>>>", response);
                                if (response.data.length > 0) {
                                    _this.isTileData = true;
                                    _this.responseData = response.data;
                                    _this.responseData.forEach(function (element) {
                                        element.status = 'offline';
                                    });
                                    console.log("Dummy Data>>>>>>", _this.responseData);
                                    _this.dataSource = new MatTableDataSource(_this.responseData);
                                    _this.dataSource.paginator = _this.paginator;
                                    _this.dataSource.sort = _this.sort;
                                    console.log('DataSource>>>>>>>', _this.dataSource);
                                }
                                else {
                                    _this.isTileData = false;
                                }
                                _this.ngxLoader.stopLoader('tile');
                            })];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 6:
                        if (!(state.toLowerCase() == 'alert')) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.feederService.getFeederPopupTileData({ 'feederList': this.feederList, 'state': this.state }).subscribe(function (response) {
                                console.log("RESPONSE>>>>>>", response);
                                _this.responseData = response.data;
                                _this.responseData = _this.responseData.filter(function (element) {
                                    if (element.alert.length > 0) {
                                        element.status = 'alert';
                                        return true;
                                    }
                                    else {
                                        //element.status = 'online';
                                        return false;
                                    }
                                });
                                //this.responseData = this.responseData.filter(response => response.status.toLowerCase() === 'alert');
                                if (_this.responseData.length > 0) {
                                    console.log("RESPONSE DATA>>>>>>", _this.responseData);
                                    _this.isTileData = true;
                                    console.log("Dummy Data>>>>>>", _this.responseData);
                                    _this.dataSource = new MatTableDataSource(_this.responseData);
                                    _this.dataSource.paginator = _this.paginator;
                                    _this.dataSource.sort = _this.sort;
                                    console.log('DataSource>>>>>>>', _this.dataSource);
                                }
                                else {
                                    _this.isTileData = false;
                                }
                                _this.ngxLoader.stopLoader('tile');
                            })];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 8:
                        if (!(state.toLowerCase() == 'normal')) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.feederService.getFeederPopupTileData({ 'feederList': this.feederList, 'state': this.state }).subscribe(function (response) {
                                console.log("RESPONSE>>>>>>", response);
                                _this.responseData = response.data;
                                _this.responseData = _this.responseData.filter(function (element) {
                                    if (element.alert.length == 0) {
                                        element.status = 'normal';
                                        return true;
                                    }
                                    else {
                                        return false;
                                    }
                                });
                                console.log("RESPONSE DATA>>>>>>", _this.responseData);
                                if (_this.responseData.length > 0) {
                                    _this.isTileData = true;
                                    console.log("Dummy Data>>>>>>", _this.responseData);
                                    _this.dataSource = new MatTableDataSource(_this.responseData);
                                    _this.dataSource.paginator = _this.paginator;
                                    _this.dataSource.sort = _this.sort;
                                    console.log('DataSource>>>>>>>', _this.dataSource);
                                }
                                else {
                                    _this.isTileData = false;
                                }
                                _this.ngxLoader.stopLoader('tile');
                            })];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    FeederpopupComponent.prototype.getAlertTileData = function (state) {
        var _this = this;
        this.ngxLoader.startLoader('alert');
        this.dataSource = null;
        this.feederService.getFeederAlertTileData({ 'feederList': this.feederList, 'state': state }).subscribe(function (response) {
            console.log('RESPONSE FROM ALERT TABLE >>>>>>', response);
            if (response.data.length > 0) {
                _this.isAlertData = true;
                _this.dataSource = new MatTableDataSource(response.data);
                _this.dataSource.paginator = _this.paginator;
                _this.dataSource.sort = _this.sort;
            }
            else {
                _this.isAlertData = false;
            }
            _this.ngxLoader.stopLoader('alert');
        });
    };
    FeederpopupComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    FeederpopupComponent.prototype.alertdata = function (feederid) {
        var _this = this;
        //console.log('On Hover');
        this.alerts = '';
        //console.log("ejkejdked....",switchid)
        this.responseData.forEach(function (element) {
            if (element.id == feederid) {
                //console.log('element>>>>>',element);
                //console.log("THIS IS AN Alert")
                if (element.status.toLowerCase() == 'alert') {
                    //console.log('ALERTS>>>>>', element.alert);
                    for (var i = 0; element.alert.length > i; i++) {
                        _this.alerts += element.alert[i] + ', ';
                    }
                    //console.log('ALERTS>>>>>', this.alerts);
                }
            }
        });
    };
    FeederpopupComponent.prototype.getStatusColor = function (status) {
        switch (status) {
            case 'online':
                return 'green'; // Red dot for online status
            case 'offline':
                return 'black'; // Black dot for offline status
            case 'normal':
                return 'green'; // Blue dot for normal status
            case 'alert':
                return 'red'; // Red dot for alert status
            default:
                return 'gray'; // Default fallback color
        }
    };
    return FeederpopupComponent;
}());
export { FeederpopupComponent };
